module.exports = __webpack_public_path__ + "static/img/8.1e976a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/sp/8.png
// module id = DuEL
// module chunks = 0